// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Reaction_wrapper__1eeQw","count":"Reaction_count__1yVue"};